// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"6824bdd7","839":"c08b2b4c"}[chunkId] + ".chunk.js";
};